import { createContext } from 'react';
import { useToggle } from '@/utils';

export const MaskingContext = createContext<any>(null);

export const MaskingProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const [blur, toggleBlur] = useToggle(true);

  return (
    <MaskingContext.Provider value={{ blur, toggleBlur }}>
      {children}
    </MaskingContext.Provider>
  );
};
